export const HOME_ROUTE = '';
export const PROJECTS_ROUTE = 'projects';
export const BLOG_ROUTE = 'blog-posts';
export const RESUME_ROUTE = 'resume';
export const CONTACT_ROUTE = 'contact';